import React, { FunctionComponent } from 'react';
import { Button } from '@bringg/react-components';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';

interface Props {
	reset: () => void;
	dirty: boolean;
	valid: boolean;
	formErrors?: Record<string, Object>;
	loading?: boolean;
	revert_text?: string;
	save_text?: string;
	unsaved_changes_text?: string;
	showFormErrors?: boolean;
}

const DEFAULT_REVERT_TEXT = 'revert back';
const DEFAULT_SAVE_TEXT = 'Save changes';
const DEFAULT_UNSAVED_CHANGES_TEXT = 'Unsaved changes have been made,';

const FormSave: FunctionComponent<Props> = ({
	reset,
	dirty,
	valid,
	loading,
	formErrors,
	showFormErrors,
	revert_text = DEFAULT_REVERT_TEXT,
	save_text = DEFAULT_SAVE_TEXT,
	unsaved_changes_text = DEFAULT_UNSAVED_CHANGES_TEXT
}) => {
	const revert = () => reset();

	const getErrorMessages = (errors): string[] => {
		return Object.values(errors).reduce((acc: string[], error: any) => {
			return acc.concat(error?.message ? error.message : getErrorMessages(error));
		}, []);
	};

	return (
		dirty && (
			<div className="form-save save-body">
				<div className="save-info">
					<div className="revert-form">
						<BringgIcon iconName={BringgFontIcons.InfoFilled} className="revert-info-icon" />
						<span className="revert-form-text">{unsaved_changes_text} </span>
						<span className="revert-form-action" onClick={revert}>
							{revert_text}
						</span>
					</div>

					{showFormErrors && formErrors && (
						<div className="form-errors">
							{getErrorMessages(formErrors).map((message, index) => {
								return (
									<span key={`form-error-${index}`} className={'form-error-message'}>
										<BringgIcon iconName={BringgFontIcons.Warning} className="form-error-icon" />
										{message}
									</span>
								);
							})}
						</div>
					)}
				</div>
				{/* submit button should be disabled only if user can see form errors */}
				{/*  otherwise form will be disabled(if invalid) and user won't know why */}
				<Button loading={loading} className="save-button" htmlType="submit" disabled={showFormErrors && !valid}>
					{save_text}
				</Button>
			</div>
		)
	);
};

export default FormSave;
